import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { Settings } from "src/model/class/settings";

/**
 * Selector for server settings
 */
export const serverSettings = createFeatureSelector<Settings>(
  AppSettings.KEY_SETTINGS
);

/**
 * Whether the current user may edit a weekly-planning's registry data: its name, description,
 * address, thresholds and the calendars assigned to it, plus creating, deleting and
 * activating/deactivating plannings.
 *
 * Backed by the `AllowWeeklyPlanningEditOption` server function, granted to building
 * administrators, maintainers and system users — but not to residents (condomini), who are
 * limited to the daily sectors (see {@link canEditWeeklyPlanningDailySector}).
 *
 * Resolves to `false` while the settings are not loaded yet, so the UI stays closed until the
 * server has stated otherwise.
 */
export const canEditWeeklyPlanningOption = createSelector(
  serverSettings,
  (settings: Settings): boolean =>
    Settings.isEnabled(settings?.AllowWeeklyPlanningEditOption)
);

/**
 * Whether the current user may edit the daily sectors (time-slices) of a weekly-planning.
 *
 * Backed by the `AllowWeeklyPlanningEditDailySector` server function, granted to building
 * administrators, maintainers, system users and residents (condomini) alike: for a resident this
 * is the only weekly-planning permission, see {@link canEditWeeklyPlanningOption}.
 *
 * Resolves to `false` while the settings are not loaded yet, so the UI stays closed until the
 * server has stated otherwise.
 */
export const canEditWeeklyPlanningDailySector = createSelector(
  serverSettings,
  (settings: Settings): boolean =>
    Settings.isEnabled(settings?.AllowWeeklyPlanningEditDailySector)
);
